import DOMPurify from "dompurify";

/**
 * Configuration for rich-text HTML coming from translations (Lokalise) or
 * other trusted-ish sources that legitimately contain markup.
 *
 * The default DOMPurify HTML profile already allows the tags and attributes
 * used by our translation strings (h1, p, a, span, br, href, rel, style,
 * name) and safe URI schemes (https, mailto, tel). `target` is stripped by
 * DOMPurify by default, but our translations use target="_blank", so we
 * explicitly allow it.
 */
const RICH_TEXT_CONFIG = {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target"],
};

/**
 * Sanitizes an HTML string before it is passed to dangerouslySetInnerHTML.
 * Keeps legitimate formatting markup but removes anything executable
 * (script tags, event handlers, javascript: URLs, etc.).
 */
export const sanitizeHtml = (html?: string | null): string =>
    DOMPurify.sanitize(html ?? "", RICH_TEXT_CONFIG);

/**
 * Sanitizes a plain-text value (e.g. group or product names, URLs) that is
 * interpolated into an HTML string. All markup is stripped, only text is
 * kept. i18next is configured with `escapeValue: false`, so interpolated
 * values MUST be run through this before ending up in
 * dangerouslySetInnerHTML.
 */
export const sanitizeText = (value?: string | null): string =>
    DOMPurify.sanitize(value ?? "", { USE_PROFILES: { html: false } });
